<template>
  <div id="app">
    <NavBar ref="navbar" @toggle-menu="toggleMenu" />
    <MegaMenu ref="megamenu" :menuActive="navbarActive" />

    <div class="router-shell" ref="routerShell">
      <!-- <transition name="fade" mode="out-in"> -->
      <transition v-on:before-leave="beforeLeave" name="fade" mode="out-in">
        <router-view @open-menu="openMenu" ref="router">
          <!-- <component :is="Component"></component> -->
        </router-view>
      </transition>
      <!-- </transition> -->
    </div>

    <Footer />
    <svg class="noise-filter">
      <filter id="noiseFilter">
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.6"
          stitchTiles="stitch"
        />
      </filter>
    </svg>
    <!-- <ThreeBackground :menuActive="navbarActive" /> -->
    <ThreeBackground :menuActive="navbarActive" />
  </div>
</template>
<script>
import ThreeBackground from "@/components/ThreeBackground";
import NavBar from "@/components/NavBar";
import MegaMenu from "@/components/MegaMenu";
import Footer from "@/components/Footer";
// import { CursorFx } from '@luxdamore/vue-cursor-fx';

import { useTransitionComposable } from "./composables/transition-composable";
const { toggleTransitionComplete } = useTransitionComposable();

const BASE_CONFIG = {
  lerps: {
    dot: 1,
    circle: 0.18,
    custom: 0.23,
  },
  scale: {
    ratio: 0.15,
    min: 1,
    max: 1.5,
  },
  opacity: 0.1,
};

export default {
  name: "Home",
  components: {
    ThreeBackground,
    NavBar,
    MegaMenu,
    Footer,
    // CursorFx,
  },
  data() {
    return {
      navbarActive: false, //temp
      menu: null,
      animating: false,
      BASE_CONFIG: BASE_CONFIG,
    };
  },
  metaInfo: {
    title: "Lucas McCallum",
    // override the parent template and just use the above title only
    titleTemplate: `%s - Lucas McCallum`,
  },
  watch: {
    navbarActive: function (active) {
      this.navbarActive = active;
    },
    $route: function () {
      //If route has changed, and navbar is active, that means it came from the mega menu. Close it.
      if (this.navbarActive) {
        // this.$refs.navbar.isActive = false;
        this.toggleMenu();
      }
      // this.$nextTick(() => this.$refs.cursor.refresh());
    },
  },
  methods: {
    toggleMenu: function () {
      this.navbarActive = !this.navbarActive;
      this.$refs.navbar.menuToggle;
      this.$refs.navbar.isActive = this.navbarActive;
      toggleTransitionComplete(false);
      this.navbarActive ? this.menu.play() : this.menu.reverse();
    },

    openMenu: function () {
      if (!this.navbarActive) {
        this.toggleMenu();
      }
    },
    beforeLeave: function (to, from, next) {
      this.gsap.to(this.$refs.router, {
        opacity: 0,
        duration: 0.5,
        onComplete: () => {
          window.scrollTo(0, 0);
          //   next();
        },
      });
    },
  },
  mounted() {
    // this.$refs.cursor.start();
    toggleTransitionComplete(true);
    this.navbarActive = this.$refs.navbar.isActive;
    const menuItems = this.$refs.megamenu.$el.querySelectorAll(
      ".main-navigation .nav-item",
    );
    const menuTl = this.gsap.timeline({
      paused: true,
      onComplete: () => {
        toggleTransitionComplete(true);
      },
      onReverseComplete: () => {
        toggleTransitionComplete(true);
      },
    }); // Maybe this should be stored somewhere
    menuTl.fromTo(
      this.$refs.routerShell,
      {
        opacity: 1,
        // Pages should have their own mounted() transition.
        // x: 0,
        display: "flex",
      },
      {
        duration: 0.5,
        opacity: 0,
        // x: -30,
        display: "none",
      },
    );
    menuTl.fromTo(
      this.$refs.megamenu.$el,
      {
        opacity: 0,
        display: "none",
      },
      {
        duration: 0.5,
        opacity: 1,
        display: "flex",
      },
    );
    menuTl.fromTo(
      this.$refs.megamenu.$el.querySelector(".mega-menu-shell--content"),
      {
        x: 50,
        y: 10,
      },
      {
        duration: 0.5,
        x: 0,
        y: 0,
      },
      "-=0.5",
    );
    menuTl.fromTo(
      menuItems,
      {
        x: 30,
      },
      {
        duration: 0.5,
        x: 0,
        stagger: {
          each: 0.1,
        },
      },
      "-=0.75",
    );

    this.menu = menuTl;
  },
};
</script>

<style src="@luxdamore/vue-cursor-fx/dist/CursorFx.css"></style>

<style lang="scss">
@import "/style/main.scss";
</style>
